import { create } from "../../../common/utils/zustand_state_manager";
import { useRhServices } from "./use_services";
import { RhRepository } from "../../../features/rh/data/repositories/rh_repository";
import { IRhRepository } from "../../../features/rh/domain/repositories/rh_repository";

/**
 * useRhRepositories
 */

type State = {
  rhRepository: IRhRepository,
};

export const useRhRepositories = create<State>((set, get) => {
  const { rhService } = useRhServices.getState();
  return ({
    rhRepository: new RhRepository(rhService),
  });
});